import React from "react";
import { Lock, Sparkles as SparklesIcon } from "lucide-react";
import { Link } from "react-router-dom";

export default function LockedOverlay({ onUnlock, oneTimePrice, tier }) {
  return (
    <div
      className="absolute inset-0 z-10 flex flex-col items-center justify-center backdrop-blur-2xl bg-noir-base/75 border border-pink-hot/20 p-6 text-center"
      data-testid="locked-overlay"
    >
      <div className="w-12 h-12 rounded-full border border-pink-hot/60 flex items-center justify-center mb-4 glow-pink">
        <Lock className="w-5 h-5 text-pink-hot" />
      </div>
      <div className="font-display italic text-2xl text-champagne mb-1">Premium Access</div>
      <div className="text-xs tracking-[0.25em] uppercase text-pink-blush/80 mb-5 flex items-center gap-2 justify-center">
        <SparklesIcon className="w-3 h-3" /> Members only
      </div>

      <div className="flex flex-col gap-2 w-full max-w-[220px]">
        <Link
          to="/account"
          className="px-5 py-2.5 bg-pink-hot text-white text-[11px] tracking-[0.28em] uppercase rounded-sm hover:bg-pink-glow glow-pink transition-all"
          data-testid="subscribe-cta"
        >
          Subscribe
        </Link>
        {oneTimePrice && (
          <button
            onClick={onUnlock}
            className="px-5 py-2.5 bg-transparent border border-pink-hot/50 text-pink-blush text-[11px] tracking-[0.28em] uppercase rounded-sm hover:border-pink-hot hover:bg-pink-hot/10 transition-all"
            data-testid="unlock-one-time-btn"
          >
            Unlock · ${oneTimePrice.toFixed(2)}
          </button>
        )}
      </div>
    </div>
  );
}
